module.exports = __webpack_public_path__ + "static/nsf-logo-black-df6fc8bf111ab1e4a86b3385d8ec4f46.png";